import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6" }
const _hoisted_23 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_24 = { class: "required" }
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_32 = { class: "col-lg-8 fv-row" }
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "row mb-6" }
const _hoisted_36 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_37 = { class: "col-lg-8 fv-row" }
const _hoisted_38 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_39 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_40 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_41 = { class: "indicator-label" }
const _hoisted_42 = { class: "indicator-progress" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('update', 'vehicle-types'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateVehicle')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.shipmentSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('arabicName')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('nameArLang'),
                      "model-value": _ctx.titleAr()
                    }, null, 8, ["placeholder", "model-value"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('englishName')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('englishName'),
                      "model-value": _ctx.titleEn()
                    }, null, 8, ["placeholder", "model-value"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('kurdishName')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleKu",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('nameKuLang'),
                      "model-value": _ctx.titleKu()
                    }, null, 8, ["placeholder", "model-value"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "titleKu" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.translate('sizes')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "size",
                      class: "form-select form-select-solid form-select-lg text-capitalize",
                      modelValue: _ctx.vehicle.size,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vehicle.size) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.translate('selectsize')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizes, (size) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: size.id,
                            value: size.id
                          }, _toDisplayString(size.title.find((i) => {
                        return i.title;
                      }).title), 9, _hoisted_27))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_ErrorMessage, { name: "size" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.translate('modelYear')), 1),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "modelYear",
                      min: "1900",
                      max: "2099",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('modelYear'),
                      modelValue: _ctx.vehicle.modelYear,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vehicle.modelYear) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_ErrorMessage, { name: "modelYear" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.translate('status')) + ": ", 1),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("label", _hoisted_38, [
                      _createVNode(_component_Field, {
                        class: "form-check-input",
                        name: "isactive",
                        type: "checkbox",
                        value: true,
                        checked: "checked",
                        modelValue: _ctx.vehicle.isactive,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vehicle.isactive) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_40, [
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_42, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_43
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}